import React from 'react';

import {makeToolTipUrl} from "utils/DBUtils";

export const ListicleHeadlineToolTip = (props) => (
  <div>
    The title of the break.  Featured on: DB homepage, top of the break and the landing page of sponsored breaks.  Editorial breaks pre-populate headline from the "Break Title" in the General break information section.
    <br/>
    <img src={makeToolTipUrl('listicle/1.CMS-Listicle-Headline.png')} width="100%"/>
  </div>
);

export const ListicleHeaderImageToolTip = (props) => (
  <div>
    Lead image that accompanies the article.
    <br/>
    <img src={makeToolTipUrl('listicle/2.CMS-Listicle-header-Image.png')} width="100%"/>
  </div>
);

export const ListicleIntroToolTip = (props) => (
  <div>
    Copy to introduce the list.
    <br/>
    <img src={makeToolTipUrl('listicle/3.CMS-Listicle-Intro.png')} width="100%"/>
  </div>
);

export const ListicleShowSharingHoverToolTip = (props) => (
  <div>
    If yes, displays sharing icons on the left side of each list item upon rollover. (Facebook, Twitter, Pinterest, Emial, Print)
    <br/>
    <img src={makeToolTipUrl('listicle/4.CMS-Listicle-social-hover-sharing-bar.png')} width="100%"/>
  </div>
);

export const ListicleDefaultShowNumbersToolTip = (props) => (
  <div>
    If yes, list items will be numbered sequentially.
    <br/>
    <img src={makeToolTipUrl('listicle/5.CMS-Listicle-show-numbered-list.png')} width="100%"/>
  </div>
);

export const ListicleDefaultAllowVotingToolTip = (props) => (
  <div>
    If yes, two buttons will appear after each list item to encourage reader interaction by voting.
    <br/>
    <img src={makeToolTipUrl('listicle/6.CMS-Listicle-allow-voting.png')} width="100%"/>
  </div>
);

export const ListicleDefaultUpvoteButtonTextToolTip = (props) => (
  <div>
    Text that appears in the upward voting button.
    <br/>
    <img src={makeToolTipUrl('listicle/7.CMS-Listicle-upvote-button-text.png')} width="100%"/>
  </div>
);

export const ListicleDefaultUpvoteButtonIconToolTip = (props) => (
  <div>
    Icon that appears in the upward voting button.  You can browse from <a href="https://fontawesome.com/v4.7.0/icons/" target="_blank">available icons</a>.
    <br/>
    <img src={makeToolTipUrl('listicle/8.CMS-Listicle-upvote-button-icon.png')} width="100%"/>
  </div>
);

export const ListicleDefaultDownvoteButtonTextToolTip = (props) => (
  <div>
    Text that appears in the downward voting button.
    <br/>
    <img src={makeToolTipUrl('listicle/9.CMS-Listicle-downvote-button-text.png')} width="100%"/>
  </div>
);

export const ListicleDefaultDownvoteButtonIconToolTip = (props) => (
  <div>
    Icon that appears in the downward voting button.  You can browse from <a href="https://fontawesome.com/v4.7.0/icons/" target="_blank">available icons</a>.
    <br/>
    <img src={makeToolTipUrl('listicle/10.CMS-Listicle-downvote-button-icon.png')} width="100%"/>
  </div>
);

export const ListicleShowNumbersToolTip = (props) => (
  <div>
    If no, this item will not be numbered when the "Show numbered list" is turned on.
    <br/>
    <img src={makeToolTipUrl('listicle/5.CMS-Listicle-show-numbered-list.png')} width="100%"/>
  </div>
);

export const ListicleAllowVotingToolTip = (props) => (
  <div>
    If no, this item will not have voting icons when "Allow voting" is turned on.
    <br/>
    <img src={makeToolTipUrl('listicle/6.CMS-Listicle-allow-voting.png')} width="100%"/>
  </div>
);

export const ListicleUpvoteButtonTextToolTip = (props) => (
  <div>
    Text that appears in the upward voting button for this list item.
    <br/>
    <img src={makeToolTipUrl('listicle/7.CMS-Listicle-upvote-button-text.png')} width="100%"/>
  </div>
);

export const ListicleUpvoteButtonIconToolTip = (props) => (
  <div>
    Icon that appears in the upward voting button for this list item.  You can browse from <a href="https://fontawesome.com/v4.7.0/icons/" target="_blank">available icons</a>.
    <br/>
    <img src={makeToolTipUrl('listicle/8.CMS-Listicle-upvote-button-icon.png')} width="100%"/>
  </div>
);

export const ListicleDownvoteButtonTextToolTip = (props) => (
  <div>
    Text that appears in the downward voting button for this list item.
    <br/>
    <img src={makeToolTipUrl('listicle/9.CMS-Listicle-downvote-button-text.png')} width="100%"/>
  </div>
);

export const ListicleDownvoteButtonIconToolTip = (props) => (
  <div>
    Icon that appears in the downward voting button for this list item.  You can browse from <a href="https://fontawesome.com/v4.7.0/icons/" target="_blank">available icons</a>.
    <br/>
    <img src={makeToolTipUrl('listicle/10.CMS-Listicle-downvote-button-icon.png')} width="100%"/>
  </div>
);

export const ListicleAddTrackingToVotingButtonsToolTip = (props) => (
  <div>
    Additional code to track readers who click the voting buttons.
  </div>
);

export const ListicleShowSharingOnItemToolTip = (props) => (
  <div>
    If no, sharing icons will be removed on this list item when "Show Social Sharing" is turned on.
    <br/>
    <img src={makeToolTipUrl('listicle/4.CMS-Listicle-social-hover-sharing-bar.png')} width="100%"/>
  </div>
);

export const ListicleItemSocialShareImageToolTip = (props) => (
  <div>
    Customized social sharing image for this article.
  </div>
);

export const ListicleItemSubheadToolTip = (props) => (
  <div>
    Title of this item in the list.  While the character limit is 200, we encourage trying to keep this field under 100 characters.
    <br/>
    <img src={makeToolTipUrl('listicle/11.CMS-Listicle-subhead.png')} width="100%"/>
  </div>
);

export const ListicleItemBodyCopyToolTip = (props) => (
  <div>
    Main copy for this list item.
    <br/>
    <img src={makeToolTipUrl('listicle/12.CMS-Listicle-bodycopy.png')} width="100%"/>
  </div>
);

export const ListicleItemBlockquoteToolTip = (props) => (
  <div>
    Visual callout of a specific quote in the text.
    <br/>
    <img src={makeToolTipUrl('listicle/13.CMS-Listicle-blockquote.png')} width="100%"/>
  </div>
);

export const ListicleImageToolTip = (props) => (
  <div>
    The type of image you are adding.  You have to determine the orientation: horizontal, vertical or custom.
    <img src={makeToolTipUrl('listicle/14.CMS-Listicle-list-item-img-style.png')} width="100%"/>
  </div>
);

export const ListicleImageScalingToolTip = (props) => (
  <div>
    Image will upload at 100%, 75% or 65% of the width of the page.  Sponsored content will typically use 75%.
    <img src={makeToolTipUrl('listicle/15.CMS-Listicle-scale-img-width.png')} width="100%"/>
  </div>
)

export const ListicleEmbedToolTip = (props) => (
  <div>
    Paste HTML code to embed a video.
  </div>
)



// WEBPACK FOOTER //
// ./public/components/break/tooltips/listicle-tool-tips.jsx